export default __webpack_public_path__ + "static/media/paddelplayer4.713e1239.png";